<template>
  <el-pagination class="page-box" @size-change="handleSizeChange"
                 @current-change="handleCurrentChange"
                 :current-page="childMsg.currentPage"
                 :page-size="childMsg.pageSize"
                 layout="total, prev, pager, next, jumper" :total="childMsg.total">
  </el-pagination>
</template>
<script>
export default {
  name: 'Pagination',
  props: ['childMsg'],
  data() {
    return {
      pageparm: {
        currentPage: this.childMsg.currentPage,
        pageSize: this.childMsg.pageSize
      }
    }
  },
  created() {},
  methods: {
    handleSizeChange(val) {
      this.pageparm.pageSize = val
      this.$emit('callFather', this.pageparm)
    },
    handleCurrentChange(val) {
      this.pageparm.currentPage = val
      this.$emit('callFather', this.pageparm)
    }
  }
}
</script>

<style>
.page-box {
  margin: 10px auto;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue